require('./openYoungInformationProfileSection.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const openYoungProfilesActions = require('actions/openYoungProfiles');

class OpenYoungInformationProfileSection extends React.Component {
    componentDidMount() {
        const {immOpenYoungProfiles} = this.props;

        if (!immOpenYoungProfiles.get('fetchSuccess')) {
            this.props.getOpenYoungProfiles();
        }
    }

    render() {
        const {immOpenYoungProfiles} = this.props;
        let content = null;

        if (immOpenYoungProfiles.get('isFetching')) {
            return <LoadingSection />;
        }
        
        if (immOpenYoungProfiles.get('fetchSuccess') && immOpenYoungProfiles.get('byId').size > 0) {
            const thereIsChild = immOpenYoungProfiles.get('byOrder').some(profileId => {
                return immOpenYoungProfiles.getIn(['byId', profileId, 'isUnder18']);
            });

            if (thereIsChild) {
                content = (
                    <OKSectionBox className="open-young-information-profile-section" title={formatText('profile-profile_openYoungTitle')}>
                        <div className="row">
                            <div className="col-xs-12 content-no-padding open-young-information-profile-section__description">
                                <FormattedText value="profile-profile_openYoungDescription" />
                            </div>
                            <div className="col-xs-12 content-no-padding open-young-information-profile-section__last-cell">
                                <OKLink modifier="complementary" to="/myprofile/openyoung-profiles">
                                    <FormattedText value="profile-profile_openYoungLink" />
                                </OKLink>
                            </div>
                        </div>
                    </OKSectionBox>
                );
            }
        }
        return content;
    }
}

OpenYoungInformationProfileSection.propTypes = {
    getOpenYoungProfiles: PropTypes.func.isRequired,
    immOpenYoungProfiles: PropTypes.object.isRequired,
}

module.exports.constructor = OpenYoungInformationProfileSection;

module.exports.OpenYoungInformationProfileSection = connect(
    state => ({
        immOpenYoungProfiles: state.openYoungProfiles,
    }), {
        getOpenYoungProfiles: openYoungProfilesActions.getOpenYoungProfiles,
    }
)(OpenYoungInformationProfileSection);
